/**
 * Auth API — self-service password management endpoints (#320).
 *
 * `forgotPassword` and `resetPassword` are PUBLIC — the request interceptor
 * attaches a bearer token only when one is present, and the backend ignores
 * it for these routes. `changePassword` is authenticated and lives behind
 * the standard `/auth/change-password` endpoint.
 */

import api from './api';

export async function forgotPassword(email: string): Promise<{ message: string }> {
  const res = await api.post('/auth/forgot-password', { email });
  return res.data;
}

export interface ResetPasswordResponse {
  success?: boolean;
  mfa_required?: boolean;
}

export async function resetPassword(
  token: string,
  newPassword: string,
  mfaCode?: string,
): Promise<ResetPasswordResponse> {
  const body: { token: string; newPassword: string; mfaCode?: string } = { token, newPassword };
  if (mfaCode && mfaCode.length > 0) body.mfaCode = mfaCode;
  const res = await api.post('/auth/reset-password', body);
  return res.data;
}

export async function changePassword(
  currentPassword: string,
  newPassword: string,
): Promise<{ message: string }> {
  const res = await api.post('/auth/change-password', { currentPassword, newPassword });
  return res.data;
}
